// Login.tsx
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { loginAdminAsync } from "../store/authSlice"; // Import the login action
import { AppDispatch, RootState } from "../store/store";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch: AppDispatch = useDispatch(); // Properly type the dispatch function
  const navigate = useNavigate();
  const { loading, error } = useSelector((state: RootState) => state.auth);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const credentials = { email_or_username: email, password }; // Properly typed credentials
    const resultAction = await dispatch(loginAdminAsync(credentials));

    if (loginAdminAsync.fulfilled.match(resultAction)) {
      navigate("/control"); // Redirect to dashboard on successful login
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FDF8F8]">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <img src="/images/logo.svg" alt="" />
        </div>

        <div className="bg-white p-8 rounded-lg shadow-sm">
          <h2 className="text-2xl font-medium text-center mb-6">Admin Login</h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm">
                Email
              </label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="eg adminemail@gmail.com"
                required
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="password" className="text-sm">
                Password
              </label>
              <div className="relative">
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                >
                  {showPassword ? (
                    <EyeOff className="h-4 w-4" />
                  ) : (
                    <Eye className="h-4 w-4" />
                  )}
                </button>
              </div>
            </div>

            {error && (
              <div className="text-red-500 text-sm text-center">{error}</div>
            )}

            <div className="text-right">
              <a
                href="/forgotpassword"
                className="text-sm text-[#B87775] hover:underline"
              >
                Forgotten password?
              </a>
            </div>

            <Button
              type="submit"
              className="w-full bg-[#B87775] hover:bg-[#B87775]/90 text-white"
              disabled={loading}
            >
              {loading ? "Signing in..." : "SIGN IN"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;